import { render, staticRenderFns } from "./MedicalResume.vue?vue&type=template&id=63b1d022&scoped=true"
import script from "./MedicalResume.vue?vue&type=script&lang=js"
export * from "./MedicalResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1d022",
  null
  
)

export default component.exports